/* @flow */
/**
 * FlowEditor typename
 * @private
 * @memberof FlowEditorService
 */

/**
 * Checks if generic input should be displayed for a given name
 * @function
 * @memberof FlowEditorService
 *
 * @return boolean
 */
const shouldDisplayGenericInputFor = (name: string) => {
  name = name ? name.toLowerCase() : ''
  return name !== '' && name !== 'action' && name !== 'triggers'
}

const self = {
  shouldDisplayGenericInputFor
}

/**
 *
 * @module FlowEditorService
 * @namespace FlowEditorService
 * @version 1.0.0
 */
export default self
